module.exports = __webpack_public_path__ + "lifeology-logo-horizontal.4eacbb36274cef69cd6cd12f72105cc3.svg";